<template>
  <div class="sass_home saasIndex" @click="handClick">
    <el-tabs v-model="activeName">
      <el-tab-pane label="TPT" name="second">
        <IndexTab1 v-if='activeName == "second"'></IndexTab1>
      </el-tab-pane>
      <el-tab-pane label="中控云" name="first">
        <IndexTab0 v-if='activeName == "first"'></IndexTab0>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import indexTab0 from './components/indexTab0.vue'
import indexTab1 from './components/indexTab1.vue'
export default {
  components: {
    IndexTab0: indexTab0,
    IndexTab1: indexTab1
  },
  data() {
    return {
      activeName: 'second'
    }
  },
  mounted() {
    if (this.$route.query.type == 'TPT') {
      this.activeName = 'second'
    }
  },
  methods: {
    handClick(val) {
      if (this.activeName == 'first') {
        this.$router.push(
          { path: '/saasIndex' }
        )
      } else {
        this.$router.push(
          { path: '/saasIndex?type=TPT' }
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.saasIndex {
  :deep(.el-tabs .el-tabs__header) {
    width: 1190px;
    margin: 0px auto 2px;
  }

  :deep(.el-tabs .el-tabs__nav-wrap::after) {
    height: 0;
  }

  :deep(.el-tabs .el-tabs__nav .el-tabs__item) {
    font-size: 16px;
    font-weight: 700;
  }

  :deep(.el-tabs .el-tabs__nav .is-active) {
    color: #2A54D1;
  }
}
</style>
